var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"notFoundText"},[_vm._v("Oops. Page Not Found. :(")]),_c('div',{staticClass:"backButton",on:{"click":_vm.onBackButtonClick}},[_vm._v("Go Back")])])
}
var staticRenderFns = []

export { render, staticRenderFns }